module.exports = __webpack_public_path__ + "img/diet-3.c89a15c6.jpg";